import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
class FetchTranscript {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
	) {
		Object.freeze(this);
	}
}

export default FetchTranscript;
